import { useCallback, useMemo, useState } from 'react';
import { Grid } from '@mui/material';

import { FormPart } from '@modules/shared/components/FormPart';
import { CheckboxListField } from '@shared/fields/CheckboxListField';
import { SaveButton } from '@shared/inputs/Buttons';
import { FlexEnd } from '@styles/StyledDiv';
import { PageContent } from '@styles/CommonStyles';
import { colorTheme } from '@styles/muiTheme';
import { IKbbFormProps, IVehicleOption, IVehicleValuationOption } from '../interfaces';

export const KbbForm = ({ options, value, valuations, handleFeatureSubmit }: IKbbFormProps) => {
  const [disable, setDisable] = useState(false);

  const getLabel = useCallback(
    (option: IVehicleOption) => {
      const { optionName, categoryGroup, vehicleOptionId } = option;

      let retailAmount: number | null = 0;
      let wholeSaleAmount: number | null = 0;

      const vehicleValuationOption = valuations?.find((vvo) => vvo.id === vehicleOptionId.toString()) as IVehicleValuationOption;

      if (vehicleValuationOption) {
        retailAmount = vehicleValuationOption.retailAmount;
        wholeSaleAmount = vehicleValuationOption.wholeSaleAmount;
      }
      const label = `${categoryGroup} - ${optionName} - Retail Amount : $${retailAmount} - Wholesale $${wholeSaleAmount}`;

      return label;
    },
    [valuations]
  );

  const groups = useMemo(() => Array.from(new Set(options.map((item: IVehicleOption) => item.categoryGroup))), [options]);

  const formConfig = useMemo(
    () =>
      groups.map((group) => ({
        name: 'selectedOptions',
        label: group,
        component: CheckboxListField,
        options: options
          .filter((option) => option.categoryGroup === group)
          .map((opt) => ({
            value: opt.vehicleOptionId.toString(),
            label: getLabel(opt),
            disabled: opt.isDisabled,
            sx: {
              '&.Mui-checked': {
                color: opt.isMatchBumper ? colorTheme.palette.success.main : colorTheme.palette.primary.main,
              },
            },
          })),
      })),
    [groups, options, getLabel]
  );

  const handleOkayClick = useCallback(async () => {
    setDisable(true);
    await handleFeatureSubmit(value);
    setDisable(false);
  }, [handleFeatureSubmit, value]);

  return (
    <>
      <PageContent>
        <Grid container>
          <FormPart config={formConfig} />
        </Grid>
      </PageContent>

      <FlexEnd>
        <SaveButton
          type="button"
          label="Okay"
          disabled={disable}
          onClick={handleOkayClick}
        />
      </FlexEnd>
    </>
  );
};
